import { httpRequest } from "../../http";
import type { Correction, PeopleSelection } from "@models/Discrepancy.model";

/** Replace the people on a correction: ends it and returns the one that replaces it (MPN-2125). */
export class CommandEditCorrectionPeople {
  async run(correctionId: number, selection: PeopleSelection): Promise<Correction> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/corrections/${correctionId}/people/`;
    return httpRequest<Correction, PeopleSelection>(url, { method: "POST", body: selection });
  }
}
